export const NATIONAL_ORG_STATE_VALUE = 'NATIONAL';

export const NATIONAL_ORG_STATE_OPTION = {
  name: 'National',
  value: NATIONAL_ORG_STATE_VALUE,
};

export const TrusteesCellIds = {
  ORG_STATE: 'orgState',
  NAME: 'name',
  ADDRESS: 'address',
};

export const trusteesSectionTitle = 'Trustee';
